var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "29px",
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6819369,28.05465 C17.1992077,28.05465 17.6461917,27.8438071 18.022889,27.4221212 C18.3996093,27.000433 18.7229007,26.446617 18.992763,25.760673 L27.561446,3.37752907 C27.6964002,3.04018959 27.8004255,2.71970788 27.8735219,2.41608392 C27.9465952,2.11245997 27.9831319,1.83695531 27.9831319,1.58956996 C27.9831319,1.11727627 27.8453795,0.743388606 27.5698749,0.467906982 C27.2943933,0.192402327 26.9261249,0.05465 26.4650697,0.05465 C26.2064458,0.05465 25.9281315,0.0940078078 25.6301268,0.172723423 C25.3321452,0.251439039 25.0144731,0.352643185 24.6771106,0.476335863 L2.14215175,9.1293422 C1.54617919,9.35425054 1.04016076,9.65224372 0.624096458,10.0233218 C0.208032153,10.3943998 0,10.8441934 0,11.3727027 C0,12.0361662 0.227709905,12.5140791 0.683129716,12.8064415 C1.13855183,13.098827 1.70360812,13.3405931 2.37829859,13.5317398 L9.10844918,15.5895959 C9.58071984,15.7357656 9.96304789,15.7948023 10.2554333,15.766706 C10.5477958,15.7385867 10.8570274,15.5783458 11.1831284,15.2859834 L25.807237,1.70764338 C25.9871682,1.53897364 26.167088,1.53335439 26.3469963,1.69078562 C26.4257119,1.75826273 26.4678793,1.84540722 26.4734986,1.95221911 C26.4791178,2.05905402 26.4369504,2.15744854 26.3469963,2.24740267 L12.8361563,16.9389768 C12.5550324,17.2426008 12.3976012,17.5377843 12.3638627,17.8245275 C12.3301241,18.1112706 12.3863512,18.5020276 12.5325439,18.9967983 L14.4891497,25.5413957 C14.691558,26.2385841 14.9389549,26.8317575 15.2313403,27.3209159 C15.5237028,27.810072 16.007235,28.05465 16.6819369,28.05465 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b9de4e0390404aa3ea7d8c41d1a3bd3b.svg";
export { ForwardRef as ReactComponent };